// src/components/Footer.js
import React from 'react';
import '../styles/Footer.css'

function Footer() {
  return (
    <footer className="footer">
      <p>© 2025 Krishna Moksha Seva| Compassionate Care</p>
      <p>Emergency Contact: +91 9492446913</p>
    </footer>
  );
}

export default Footer;
